export const SET_FILTRO_LISTAGEM_USUARIO =
    'SET_FILTRO_LISTAGEM_USUARIO'

export const setFiltroListagem = (filtroListagem) => ({
    type: SET_FILTRO_LISTAGEM_USUARIO,
    filtroListagem,
})
